// extracted by mini-css-extract-plugin
module.exports = {"detail-name":"transfer_review_box__detail-name___1VHnH _type__vx_text-6___LLSOx","detail-value":"transfer_review_box__detail-value___3LU-a _type__vx_text-5_lighter___2ilC-"};